import { useState, useEffect } from "react";
import { getAuthURLClient } from "../utils/domainUtils/domainUtilsClient";

export function useAuthUrl(path: string) {
  const [url, setUrl] = useState<string>("");

  useEffect(() => {
    const requestedUrl =
      typeof window !== "undefined" ? window.location.href : "https://aws.com";
    setUrl(`${getAuthURLClient()}${path}?requestedUrl=${requestedUrl}`);
  }, [path]);

  return url;
}
